<template>
    <table class="table table-definition table-collapsed">
        <tr>
            <td>Disclaimer Text</td>
            <td>{{ action.disclaimerText }}</td>
        </tr>
        <tr>
            <td>Button Text</td>
            <td>{{ action.buttonText }}</td>
        </tr>
        <tr>
            <td>Return Link Text</td>
            <td>{{ action.returnLinkText }}</td>
        </tr>
    </table>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'show-descriptor-disclaimer-summary',
        extends: BaseActionSummary,
    };
</script>
